<template>
  <div>
    <andes-header></andes-header>
    <breadcrumb activePage="4"></breadcrumb>
    <div class="container payment-page">
      <div class="row">
        <div class="col-sm-9">
          <div class="row d-flex align-items-center text-center text-sm-left">
            <div class="col-12 col-sm-6 ">
              <h3 class="m-0">{{ $t('REALIZAR PAGO') }}</h3>
            </div>
            <div class="col-12 col-sm-6">
              <div class="reservation text-center" v-if="booking.Payments && booking.Payments.length">{{ $t('Reserva:') }} {{ booking.RecordLocator }}</div>
            </div>
          </div>
          <hr/>
          <div class="itin">
            <payment-summary class="mb-3" v-if="booking.Payments && booking.Payments.length"></payment-summary>
          </div>

          <div class="card shadow mt-3" v-if="booking.BalanceDue > 0">
            <div class="card-body">
              <h3 class="total-title">{{ $t('TOTAL A PAGAR:') }}  <span>ARS {{toCurrencyFormat(booking.BalanceDue)}}</span></h3>
              <hr/>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <summary-form :onContinue="onContinue" :terms="true"></summary-form>
        </div>
      </div>
    </div>
    <loading-modal v-if="loading"></loading-modal>
    <session-timeout-modal></session-timeout-modal>
  </div>
</template>

<script>
  import SummaryForm from "../components/SummaryForm";
  import Breadcrumb from "../components/Breadcrumb";
  import { mapState } from 'vuex';
//  import MpForm from "../components/payment/MercadoPagoForm";
  //import MpCashForm from "../components/payment/MercadoPagoCashForm";
  import AndesHeader from "../components/AndesHeader";
  import LoadingModal from "../components/LoadingModal";
  import PaymentSummary from "../components/itinerary/PaymentSummary";
  import {formatMoney} from "../utils/utils";
  import SessionTimeoutModal from "../components/SessionTimeout";
  import { makePaymentV2 } from '@/api/api';
  var moment = require('moment');

  export default {
    components: {
      SessionTimeoutModal,
      PaymentSummary,
      LoadingModal,
      AndesHeader,
      //MpForm,
      //MpCashForm,
      Breadcrumb,
      SummaryForm},
    name: 'payment-page',
    computed: {
      ...mapState(['booking', 'loading', 'checkboxTerms']),
      getAP: function() {
        if (this.booking.Passengers[0] && this.booking.Passengers[0].Segments[0]
            && this.booking.Passengers[0].Segments[0].Legs && this.booking.Passengers[0].Segments[0].Legs[0]
            && this.booking.Passengers[0].Segments[0].Legs[0].InventoryLeg ) {
          let departureDate = moment(this.booking.Passengers[0].Segments[0].Legs[0].InventoryLeg.STD);
          let today = moment(new Date());
          let diff =  moment.duration(departureDate.diff(today));
          if (diff.days()>=1){
            return true;
          }
        }
        return false;
      }

    },
    data: function() {
      return {
        picked: "card"
      }
    },
    methods: {
    onContinue: async function (departureStation, arrivalStation, sta, std) {

      if (!this.checkboxTerms) {
       this.$store.commit('termsError', true);
       return;
      }
      
      const staUTC = moment(sta).utc().format();
      const stdUTC = moment(std).utc().format();
      

      if (this.booking.BalanceDue <= 0) {
        this.$router.replace("itinerary");
      } else {
        this.$store.commit('loading', true);
       await makePaymentV2(this.booking, departureStation, arrivalStation, staUTC, stdUTC, (response) => {
         if (response && response.URL) {
           window.location.href = response.URL;
         } else {
           this.$store.commit('loading', false);
           this.$store.commit('error', 'Error al procesar el pago. Por favor,  intente nuevamente.');    
         }
      });
       }
     },
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      }
    }, mounted() {
      if (_.isEmpty(this.booking)){
       this.$router.replace('/');
      }
    }
  }
</script>

